export const GET_HOME_PAGE_WIDGET = "GET_HOME_PAGE_WIDGET"
export const GET_HOME_PAGE_WIDGET_FAIL = "GET_HOME_PAGE_WIDGET_FAIL"
export const GET_HOME_PAGE_WIDGET_SUCCESS = "GET_HOME_PAGE_WIDGET_SUCCESS"
export const GET_HOME_PAGE_WIDGET_RESET = "GET_HOME_PAGE_WIDGET_RESET"

export const getHomePageWidget = (params) => {
    return { type: GET_HOME_PAGE_WIDGET, params }
}
export const getHomePageWidgetFail = (response) => {
    return { type: GET_HOME_PAGE_WIDGET_FAIL, response }
}
export const getHomePageWidgetSuccess = (response) => {
    return { type: GET_HOME_PAGE_WIDGET_SUCCESS, response }
}
export const getHomePageWidgetReset = () => {
    return { type: GET_HOME_PAGE_WIDGET_RESET }
}